import moment from "moment";

import CalElev from "./CalElev";
import CalCase from "./CalCase";
import * as DbRecord from "../../services/record";
import * as media from "../../services/media";
import { isFunction, getKey, hasKey, FILES } from "../shared";
import fileSys from "../../fileoprators/fileSystem";
import { isDefined, logStdout, unZip, zip } from "../../shared/utils";
const fs = window.require("fs");
let _patient;
let _record;
let _osod;
let _mode;
let _filename;
let _shotInfo;
let _fileInfos;
let _casePath;
let _eyetype;

function logTime(str) {
  let date = new Date();
}
function addRecord() {
  return new Promise((resolve, reject) => {
    if (_record._id) {
      resolve();
    } else {
      DbRecord.addRecord(_record, (response) => {
        if (response && response.message === "OK") {
          let newRecord = response.record;
          _record = newRecord;
          resolve();
        } else {
          reject(response);
        }
      });
    }
  });
}
export const downloadCase = function (record, osod, mode) {
  return new Promise((resolve, reject) => {
    _eyetype = osod || _eyetype;
    osod = osod ? `data${osod}` : undefined;
    let arrCase = getKey(record, `content.${osod || _osod}.${mode || _mode}.photos`);
    logStdout("getcase", arrCase);
    if (!global.elevParams) {
      global.elevParams = CalElev.getDefaultParams();
    }
    if (arrCase && arrCase.length > 0 && arrCase[0].filename) {
      _casePath = fileSys.getCasePath(`${record._id}_${_eyetype}`);

      if (fileSys.isFileExists(_casePath)) {
        //   let files = fileSys.readDirectory(_casePath)
        //   files.forEach(fullpath => {
        //     fileSys.deleteFile(fullpath)
        //   })
        //   fileSys.mkdirSync(_casePath)
        // }
        resolve(_casePath);
      } else {
        let filename = arrCase[0].filename;
        logTime("download start:");
        let file = { filename, mimetype: arrCase[0].mimetype };
        let dest = fileSys.getCasePath(filename);

        media.downloadFile(file, fileSys.getCasePath(), filename, () => {
          logTime("download end:");
          logTime("unzip start:");
          try {
            unZip(dest, _casePath);
            logTime("unzip end:");
            fileSys.deleteFile(dest);
          } catch (e) {
            console.log("unzip-err", e);
          }

          resolve(_casePath);
        });
      }
    } else {
      let err = "record db is empty!";
      reject(err);
    }
  });
};
function calAndUpload(dir, shotInfo) {
  return new Promise((resolve, reject) => {
    logTime("cal start:");
    let jpg = fileSys.combinePath(dir, "original.jpg");
    // 计算

    // 0:人眼,1:模拟眼
    let eyeMaterial = isDefined(shotInfo.eyeMaterial) ? shotInfo.eyeMaterial : 0;

    let result = CalCase.calCaseData(jpg, eyeMaterial, shotInfo.eyetype === "OD");
    logTime("cal end:");

    // 打包
    let zipPath = dir + ".zip";
    logTime("zip start:");
    zip(dir, zipPath);
    logTime("zip end:");
    // 上传
    media.uploadFiles([zipPath], [], (response) => {
      if (response && response.message === "OK") {
        logTime("upload end:");
        fileSys.deleteFile(zipPath);
        resolve(response);
      } else {
        reject(response);
      }
    });
  });
}
function handleCase() {
  return new Promise((resolve, reject) => {
    if (_filename && _record._id && _shotInfo) {
      _shotInfo.shotMode = window.ctShotInfo.shotMode;
      _shotInfo.eyeMaterial = window.captureSettings.EyeMaterial;
      let dir = fileSys.getCasePath(`${_record._id}_${_eyetype}`);
      if (fileSys.isFileExists(dir)) {
        let files = fileSys.readDirectory(dir);
        files.forEach((fullpath) => {
          fileSys.deleteFile(fullpath);
        });
      }
      fileSys.mkdirSync(dir);
      let jpg = fileSys.combinePath(dir, "original.jpg");

      if (_filename !== jpg) fileSys.copyFile(_filename, jpg);
      let saveJson = {
        patient: _patient,
        record: _record,
        shotInfo: _shotInfo
      };
      fileSys.saveJsonFile(
        fileSys.getCasePath(`${_record._id}_${_eyetype}/${FILES.shotJson}`),
        saveJson
      );
      calAndUpload(dir, _shotInfo).then((response) => {
        if (response && response.message === "OK") {
          _fileInfos = response.fileInfos;

          resolve();
        } else {
          let err = "upload fail";
          reject(err);
        }
      });
    } else {
      let err = "params error";
      reject(err);
    }
  });
}
function updateRecord() {
  return new Promise((resolve, reject) => {
    if (_fileInfos && _fileInfos.length > 0) {
      _record.content = _record.content || {};
      _record.content[_osod] = _record.content[_osod] || {
        diagnosed: true,
        testtime: moment().format("yyyy-MM-dd HH:mm:ss")
      };
      let modeinfo = getKey(_record, `content.${_osod}.${_mode}`) || {};
      modeinfo.diagnosed = true;
      modeinfo.photos = _fileInfos;
      // modeinfo.ringtype = _shotInfo.ringnum
      DbRecord.updateRecord(_record, (response) => {
        if (response && response.message === "OK") {
          resolve();
        } else {
          let err = "update record failed!";
          reject(err);
        }
      });
    }
  });
}
function getPatients(callback) {
  let opt = {
    cmd: "getPatients",
    body: { page: 1, pagelength: 50 },
    token: window.token
  };
  global.httpRequest(opt, (response) => {
    if (isFunction(callback)) {
      callback(response.message === "OK" ? response.obj.patients : null);
    }
  });
}
function recurPatients(patients, patientPercent, percent, callback) {
  if (global.pauseCalAllCT === true) {
    if (isFunction(callback)) {
      callback(percent);
    }
    return;
  }
  _patient = patients.pop();
  if (_patient) {
    DbRecord.getAllRecords("topography", [], _patient._id, (records) => {
      if (!records || records.length <= 0) {
        percent += patientPercent;
        if (isFunction(callback)) {
          callback(percent);
        }
        recurPatients(patients, patientPercent, percent, callback);
        return;
      }
      let recordPercent = parseFloat(patientPercent) / parseFloat(records.length);
      recurRecords(records, recordPercent, percent, (per, complete = false) => {
        percent = per;
        if (isFunction(callback)) {
          callback(per);
        }
        if (complete === true) {
          // current patient's records cal complete
          recurPatients(patients, patientPercent, percent, callback);
        }
      });
    });
  } else {
    if (isFunction(callback)) {
      let num = 100;
      callback(num);
    }
  }
}
function recurRecords(records, recordPercent, percent, callback) {
  if (global.pauseCalAllCT === true) {
    if (isFunction(callback)) {
      callback(percent, true);
    }
    return;
  }
  _record = records.pop();

  if (_record) {
    reCal(_record, () => {
      if (isFunction(callback)) {
        percent += recordPercent;
        if (percent > 100) percent = 100;
        callback(percent);
        recurRecords(records, recordPercent, percent, callback);
      }
    });
  } else {
    if (isFunction(callback)) {
      callback(percent, true);
    }
  }
}
function reCalAll(callback) {
  getPatients((patients) => {
    if (!patients || patients.length <= 0) {
      if (isFunction(callback)) {
        let num = 100;
        callback(num);
      }
    } else {
      let percent = 0;
      let perPatient = parseFloat(100) / parseFloat(patients.length);
      recurPatients(patients, perPatient, percent, callback);
    }
  });
}
function delCaseFile() {
  return new Promise((resolve, reject) => {
    let casePath = _casePath;
    let record = _record;
    let allFiles = fs.readdirSync(casePath);
    for (let i = 0; i < allFiles.length; i++) {
      if (allFiles[i] === "original.jpg" || allFiles[i] === FILES.shotJson) {
        continue;
      }
      fileSys.deleteFile(fileSys.combinePath(casePath, allFiles[i]));
    }
    let shotJson = fileSys.readJsonFile(fileSys.combinePath(casePath, FILES.shotJson));
    let shotInfo = shotJson.shotInfo;
    let patient = shotJson.patient;
    media.delMediaFiles(getKey(record, `content.${_osod}.${_mode}.photos`), (res) => {
      resolve(fileSys.combinePath(casePath, "original.jpg"), record._id, patient, record, shotInfo);
    });
  });
}
function reCal(record, callback) {
  let arrCase = getKey(record, `content.${_osod}.${_mode}.photos`);
  if (!arrCase || arrCase.length <= 0) {
    if (isFunction(callback)) {
      let err = "case is null!";
      callback(err);
    }
    return;
  }
  downloadCase(record)
    .then(delCaseFile)
    .then(handleCase)
    .then(updateRecord)
    .then(initCase)
    .then((casePath) => {
      if (!global.elevParams) {
        global.elevParams = CalElev.getDefaultParams();
      }
      if (isFunction(callback)) {
        callback(casePath);
      }
    })
    .catch((err) => {
      if (isFunction(callback)) {
        callback(err);
      }
    });
}
function initCase(isCompare0, isCompare1) {
  return new Promise((resolve, reject) => {
    downloadCase(_record)
      .then((casePath) => {
        if (!global.elevParamsDiff0) {
          global.elevParamsDiff0 = CalElev.getDefaultParams();
        }
        if (!global.elevParamsDiff1) {
          global.elevParamsDiff1 = CalElev.getDefaultParams();
        }
        if (!global.elevParams) global.elevParams = CalElev.getDefaultParams();
        if (isCompare0) {
          if (global.elevParamsDiff0.ptrCal) {
            CalElev.free(global.elevParamsDiff0);
            global.elevParamsDiff0 = CalElev.getDefaultParams();
          }
          CalElev.cal(global.elevParamsDiff0, casePath);
        } else if (isCompare1) {
          if (global.elevParamsDiff1.ptrCal) {
            CalElev.free(global.elevParamsDiff1);
            global.elevParamsDiff1 = CalElev.getDefaultParams();
          }
          CalElev.cal(global.elevParamsDiff1, casePath);
        } else {
          if (!global.elevParams.hadInitial) {
            if (global.elevParams.ptrCal !== 0) {
              CalElev.free(global.elevParams);
              global.elevParams.ptrCal = 0;
            }
          }
          if (global.elevParams.ptrCal === 0) {
            CalElev.cal(global.elevParams, casePath);
          }
        }

        resolve(casePath);
      })
      .catch((e) => {
        reject(e);
      });
  });
}
function getCase(record, isCompare0, isCompare1, eyetype, callback) {
  _record = record;
  _patient = null;
  _shotInfo = null;
  if (!_mode) _mode = "topography";
  if (!eyetype) {
    if (hasKey(record, `content.dataOD.${_mode}.photos`)) {
      _osod = "dataOD";
      _eyetype = "OD";
    } else {
      _osod = "dataOS";
      _eyetype = "OS";
    }
  } else {
    _osod = `data${eyetype}`;
    _eyetype = eyetype;
  }
  if (global.elevParams) {
    global.elevParams.hadInitial = false;
  }
  initCase(isCompare0, isCompare1)
    .then((casePath) => {
      if (isFunction(callback)) {
        callback(casePath);
      }
    })
    .catch(() => {
      callback(null);
    });
}
function initCaseById(recordid, eyetype, isCompare0, isCompare1, callback) {
  DbRecord.getRecordContent(recordid, (result) => {
    if (result && result.record) {
      _record = result.record;
      _patient = null;
      _shotInfo = null;
      _mode = "topography";
      _eyetype = eyetype;
      _osod = `data${eyetype}`;

      initCase(isCompare0, isCompare1).then((casePath) => {
        if (isFunction(callback)) {
          callback(casePath);
        }
      });
    } else if (isFunction(callback)) {
      let obj = "";
      callback(obj);
    }
  });
}
function onTakePhoto(patient, record, osod, mode, filename, shotInfo, callback) {
  // console.log('onTakePhoto:', osod, mode, filename, shotInfo)
  _patient = patient;
  _record = record;
  _osod = osod;
  _mode = mode;
  _filename = filename;
  _shotInfo = shotInfo;
  if (_osod.indexOf("OD") >= 0) {
    _eyetype = "OD";
  } else {
    _eyetype = "OS";
  }
  addRecord()
    .then(handleCase)
    .then(updateRecord)
    // .then(() => {
    //   initCase(false, false)
    // })
    .then(() => {
      // if (!global.elevParams) {
      //   global.elevParams = CalElev.getDefaultParams()
      // }

      if (isFunction(callback)) {
        callback(null, "", _record, _casePath);
      }
    })
    .catch((err) => {
      if (isFunction(callback)) {
        console.log("err!!!!!!!!!!!!", err);
        callback(err);
      }
    });
}
function calcPupilCornea(filepath) {
  return CalCase.findPupilCornea(filepath);
}
function calcPupilCorneaVideo(filepath, callback) {
  CalCase.findPupilCorneaVideo(filepath, (data) => {
    callback(data);
  });
}
function free() {
  CalElev.free(global.elevParams);
  CalElev.free(global.elevParamsDiff0);
  CalElev.free(global.elevParamsDiff1);
  global.elevParams = global.elevParamsDiff0 = global.elevParamsDiff1 = null;
}
export default {
  downloadCase,
  onTakePhoto,
  initCaseById,
  getCase,
  free,
  reCal,
  reCalAll,
  calcPupilCornea,
  calcPupilCorneaVideo
};



// WEBPACK FOOTER //
// ./src/topography/js/CaseHandle.js